import { makeStyles } from '@fluentui/react-components';

export const useHeaderStyles = makeStyles({
  headerBar: {
    display: 'flex !important',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    background: '#2d2d2d',
    height: '56px',
    minHeight: '56px',
    maxHeight: '56px',
    overflow: 'visible',
    padding: '0 32px',
    borderBottom: 'none',
    boxSizing: 'border-box',
    width: '100%',
    position: 'relative',
    zIndex: 100,
    flexWrap: 'nowrap', 
  },
  left: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    whiteSpace: 'nowrap',
    flexShrink: 0,
    minWidth: 0,
    width: 'fit-content', 
    justifyContent: 'flex-start',
    flex: 1,
  },
  logoText: {
    marginTop: '2px',
    fontWeight: 1000,
    fontSize: '1.5rem',
    color: '#fff',
    letterSpacing: '0.08em',
    fontFamily: 'Arial Black, Arial, sans-serif',
    lineHeight: 1,
    position: 'relative',
    top: '2px',
  },
  logoLink: {
    display: 'inline-flex',
    alignItems: 'center',
    textDecoration: 'none !important',
    color: 'inherit !important',
    border: 'none !important',
    background: 'none !important',
    boxShadow: 'none !important',
    transition: 'none !important',
    cursor: 'pointer',
    lineHeight: 1,
    padding: 0,
    margin: 0,
    '&:hover': {
      textDecoration: 'none !important',
      color: 'inherit !important',
      border: 'none !important',
      background: 'none !important',
      boxShadow: 'none !important',
      transition: 'none !important',
    },
    '&:focus': {
      textDecoration: 'none !important',
      color: 'inherit !important',
      border: 'none !important',
      background: 'none !important',
      boxShadow: 'none !important',
      transition: 'none !important',
    },
    '&:active': {
      textDecoration: 'none !important',
      color: 'inherit !important',
      border: 'none !important',
      background: 'none !important',
      boxShadow: 'none !important',
      transition: 'none !important',
    },
    '&::after': {
      display: 'none !important',
      textDecoration: 'none !important',
      border: 'none !important',
      background: 'none !important',
      boxShadow: 'none !important',
      transition: 'none !important',
      content: 'none !important',
    },
  },
  divider: {
    height: '28px',
    width: '1px',
    background: '#fff',
    opacity: 0.3,
    margin: '0 16px',
    alignSelf: 'center',
    borderRadius: '1px',
    display: 'inline-block',
  },
  depotText: {
    fontWeight: 100,
    fontSize: '1.25rem',
    color: '#e0e0e0',
    letterSpacing: '0.08em',
    fontFamily: 'KantarBrownWeb-Light !important',
    lineHeight: 1,
    alignContent: 'center',
    textAlign: 'center',
    position: 'relative',
  },
  right: {
    display: 'flex',
    flex: 1,
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: '10px',
    whiteSpace: 'nowrap',
    flexShrink: 0,
    minWidth: 0,
    width: 'auto',
  },
  iconButton: {
    backgroundColor: 'transparent !important',
    boxShadow: 'none !important',
    border: 'none !important',
    color: '#fff',
    '&:hover': {
      backgroundColor: 'rgba(255,255,255,0.08) !important',
      color: '#fff',
    },
    '&:active': {
      backgroundColor: 'rgba(255,255,255,0.16) !important',
    },
  },
});
